import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { markTaskAsCompleteIncomplete } from '../../../../redux/tasks/actions';
import MarkAsLabel from '../../molecules/task-components/task-heading-card/MarkAsLabel';

const MarkCompleteTaskMenuItem = ({ taskId }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleItemClick = () => {
    dispatch(markTaskAsCompleteIncomplete(taskId, intl))
  };

  return (
    <div onClick={handleItemClick}>
      <MarkAsLabel taskId={taskId} />
    </div>
  );
};

export default MarkCompleteTaskMenuItem;
